import { fetchAgentGroups } from "../../shared/actions/AgentGroupActions";
import { AgentGroup, defaultAgentGroupName } from "../../shared/model/AgentGroup";
import { ThunkResult, Utilities } from "../../shared/utilities";
import { UrlParamAction } from "../App";
import { IAction } from "../model/IAction";
export const RECIEVE_AGENT_GROUPS = "RECEIVE_AGENT_GROUPS";
export const SET_DEFAULT_TARGET_FRAMEWORK = "SET_DEFAULT_TARGET_FRAMEWORK";

export function fetchAgentgroupsAction(isNewProcess: boolean): ThunkResult<void, null> {
    return (dispatch) => {
        fetchAgentGroups().then(
            async (groupHashes) => {
                const agentGroups = Object.keys(groupHashes).map((k) => groupHashes[k]);
                if (isNewProcess) {
                    const defaultTargetFramework = await Utilities.getFetch<string>("api/app-settings/DefaultTargetFramework")
                        .catch(() => {
                            const defaultAgentGroup = agentGroups.find((ag) => ag.name === defaultAgentGroupName);
                            return defaultAgentGroup?.isCrossPlatform ? "net8.0" : "net471";
                        });

                    dispatch<ISetDefaultTargetFrameworkAction>({
                        type: SET_DEFAULT_TARGET_FRAMEWORK,
                        targetFramework: defaultTargetFramework
                    });
                }

                return dispatch<IReceiveAgentGroupsAction>({
                    type: RECIEVE_AGENT_GROUPS,
                    agentGroups: agentGroups
                });
            });
    };
}

export interface IReceiveAgentGroupsAction extends IAction {
    agentGroups: AgentGroup[];
}

export interface ISetDefaultTargetFrameworkAction extends IAction {
    targetFramework: string;
}
